module.exports = __webpack_public_path__ + "static/img/preview_title2.091816a.png";


//////////////////
// WEBPACK FOOTER
// ./static/funding_cpunk/creation/preview_title2.png
// module id = ab6S
// module chunks = 1